<template>
  <footer class="footer">

    <!-- Top accent -->
    <div class="footer-accent-line"></div>

    <!-- Main content -->
    <div class="footer-inner">

      <!-- Brand -->
      <div class="footer-brand">
        <p class="brand-name">Plan Tech Builders</p>
        <p class="brand-tagline">
          Building stronger, smarter,<br />and sustainable structures.
        </p>
        <div class="social-row">
          <a href="https://www.instagram.com/plantechbuilders?igsh=ZmRjdjU4bzZwY3dx" target="_blank" class="social-link" aria-label="Instagram">
            <v-icon small>mdi-instagram</v-icon>
          </a>
          <a href="https://www.facebook.com/share/19ywmeAMrA/" target="_blank" class="social-link" aria-label="Facebook">
            <v-icon small>mdi-facebook</v-icon>
          </a>
          <a href="https://wa.me/918848284524" target="_blank" class="social-link" aria-label="WhatsApp">
            <v-icon small>mdi-whatsapp</v-icon>
          </a>
        </div>
      </div>

      <!-- Divider -->
      <div class="v-divider"></div>

      <!-- Quick Links -->
      <div class="footer-col">
        <p class="col-label">Quick Links</p>
        <router-link to="/" class="flink">Home</router-link>
        <router-link to="/" class="flink">About Us</router-link>
        <router-link to="/coursesPage" class="flink">Specialized</router-link>
        <router-link to="/contactUs" class="flink">Contact Us</router-link>
      </div>

      <!-- Legal -->
      <div class="footer-col">
        <p class="col-label">Legal</p>
        <router-link to="/privacypolicy" class="flink">Privacy Policy</router-link>
        <router-link to="/termsandconditions" class="flink">Terms &amp; Conditions</router-link>
      </div>

      <!-- Contact -->
      <div class="footer-col">
        <p class="col-label">Get In Touch</p>
        <a href="https://wa.me/919048493808" class="flink contact-line" target="_blank">
          <v-icon x-small class="contact-icon">mdi-phone</v-icon>
          +91 90484 93808
        </a>
        <a href="mailto:plantech110@gmail.com" class="flink contact-line">
          <v-icon x-small class="contact-icon">mdi-email-outline</v-icon>
          plantech110@gmail.com
        </a>
        <span class="flink contact-line no-hover">
          <v-icon x-small class="contact-icon">mdi-map-marker-outline</v-icon>
          Kerala, India
        </span>
      </div>

    </div>

    <!-- Bottom bar -->
    <div class="footer-bottom">
      <span class="copy">© 2025 Plan Tech Builders. All rights reserved.</span>
      <span class="credit">
        Designed &amp; Developed by
        <a href="https://cybercraftinnovations.com/" target="_blank" class="credit-link">Cyber Craft Innovations</a>
      </span>
    </div>

  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,400&family=Jost:wght@300;400;500;600&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

/* ══ WRAPPER ══ */
.footer {
  background: #f9f7f4;
  width: 100%;
  border-top: 1px solid rgba(0,0,0,0.07);
}

/* Gold top accent */
.footer-accent-line {
  height: 3px;
  background: linear-gradient(to right, transparent, #caa271 25%, #caa271 75%, transparent);
}

/* ══ INNER ══ */
.footer-inner {
  max-width: 1240px;
  margin: 0 auto;
  padding: 64px 6vw 52px;
  display: flex;
  align-items: flex-start;
  gap: 40px;
}

@media (max-width: 900px) {
  .footer-inner {
    flex-wrap: wrap;
    gap: 36px;
    padding: 48px 6vw 40px;
  }
  .v-divider { display: none; }
}

/* ══ BRAND ══ */
.footer-brand {
  flex: 1.6;
  min-width: 200px;
}

.brand-name {
  font-family: 'Jost', sans-serif;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.brand-tagline {
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 300;
  line-height: 1.85;
  color: rgba(0,0,0,0.45);
  margin-bottom: 26px;
}

/* Social */
.social-row {
  display: flex;
  gap: 10px;
}
.social-link {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(0,0,0,0.13);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: rgba(0,0,0,0.45) !important;
  transition: border-color 0.22s, background 0.22s, color 0.22s;
}
.social-link:hover {
  border-color: #caa271;
  background: #caa271;
  color: #fff !important;
}
.social-link:hover .v-icon { color: #fff !important; }
.social-link .v-icon { color: rgba(0,0,0,0.45) !important; }

/* ══ VERTICAL DIVIDER ══ */
.v-divider {
  width: 1px;
  align-self: stretch;
  background: rgba(0,0,0,0.08);
  flex-shrink: 0;
}

/* ══ LINK COLS ══ */
.footer-col {
  flex: 1;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.col-label {
  font-family: 'Jost', sans-serif;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #caa271;
  margin-bottom: 18px;
}

.flink {
  font-family: 'Jost', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: rgba(0,0,0,0.55);
  text-decoration: none;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  display: block;
  transition: color 0.2s, padding-left 0.2s;
  cursor: pointer;
}
.flink:last-child { border-bottom: none; }
.flink:hover:not(.no-hover) {
  color: #caa271;
  padding-left: 5px;
}

/* Contact lines */
.contact-line {
  display: flex !important;
  align-items: center;
  gap: 8px;
}
.contact-icon {
  color: #caa271 !important;
  flex-shrink: 0;
}
.no-hover { cursor: default; }

/* ══ BOTTOM BAR ══ */
.footer-bottom {
  max-width: 1240px;
  margin: 0 auto;
  padding: 18px 6vw 24px;
  border-top: 1px solid rgba(0,0,0,0.07);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.copy {
  font-family: 'Jost', sans-serif;
  font-size: 11px;
  font-weight: 300;
  letter-spacing: 0.5px;
  color: rgba(0,0,0,0.35);
}

.credit {
  font-family: 'Jost', sans-serif;
  font-size: 11px;
  font-weight: 300;
  color: rgba(0,0,0,0.35);
}

.credit-link {
  color: #caa271;
  text-decoration: none;
  font-weight: 400;
  transition: opacity 0.2s;
}
.credit-link:hover { opacity: 0.7; }
</style>